<template>
  <notices-detail :is-edit="false" />
</template>

<script>
import NoticesDetail from "./components/noticesDetail";

export default {
  name: "CreateForm",
  components: { NoticesDetail },
};
</script>
